module.exports = __webpack_public_path__ + "static/media/logo_6.310f88cc.svg";